(function ($) {
	'use strict';

	var ahus = {

		init: function () {

			this.mainMenuBlock();
			this.mainMenuBlock1();
			this.submenuOpener();
			this.fixedHeader();
			this.heroSlider();
			this.iconTextSlider();
			this.iconTextAltSlider();
			this.singleProductBlockSlider();
			this.newsCollageSlider();
			this.portfolioSlider();
			this.filterOpener();
			this.lightboxOverwrites();
			this.languageTrigger();




		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});
		},

		mainMenuBlock1: function () {
			jQuery('header').on('click', '.navbar-toggle-btn.nav-close', function (e) {
				jQuery('html').removeClass('submenu-active');
				jQuery('.nav-item').removeClass('opened');
				jQuery('.submenu-opener').removeClass('closed');
				jQuery('.dropdown-menu').css("display", "none");
			});
		},

		submenuOpener: function () {
			jQuery("header.main-header .navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				jQuery('html').toggleClass('submenu-active');

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).parent('.nav-item').addClass('opened');
					jQuery(this).next('.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).parent('.nav-item').removeClass('opened');
					jQuery(this).next('.dropdown-menu').slideToggle();
				}

			});

		},


		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 1) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},

		heroSlider: function () {
			var $mainslider = $('.hero-slider')


			// Slick Slider Options
			$mainslider.slick({
				draggable: true,
				arrows: false,
				dots: true,
				fade: true,
				infinite: true,
				speed: 300,
				pauseOnHover: true, 
			});

		},

		iconTextSlider: function () {
			mobileOnlySlider(".icon-text-block-slider", false, true, 991);

			function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
				var slider = $($slidername);
				var settings = {
					mobileFirst: true,
					dots: $dots,
					arrows: $arrows,
					autoplay: false,
					infinite: false,
					slidesToShow:2,

					responsive: [
						
						{
							breakpoint: $breakpoint,
							settings: "unslick",

						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3,
							}
						},
						

					]
				};

				slider.slick(settings);

				$(window).on("resize", function () {
					if ($(window).width() > $breakpoint) {
						return;
					}
					if (!slider.hasClass("slick-initialized")) {
						return slider.slick(settings);
					}
				});
			} // Mobile Only Slider
		},

		iconTextAltSlider: function () {
			jQuery('.icon-text-block-slider-alt').slick({
				dots: false,
				arrows: true,
				infinite: true,
				speed: 1000,
				slidesToShow: 5,
				slidesToScroll: 1,
				variableWidth: false,
				centerMode: true,
				centerPadding: 0,
				responsive: [

					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						}
					},
					
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						}
					},
				]
			});
		},

		singleProductBlockSlider: function () {
			jQuery('.single-product-block-slider').slick({
				dots: false,
				arrows: true,
				infinite: true,
				speed: 1000,
				slidesToShow: 4,
				slidesToScroll: 1,
				variableWidth: false,
				centerMode: true,
				centerPadding: 0,
				responsive: [

					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						}
					},
				]
			});
		},

		newsCollageSlider: function () {
			jQuery('.news-collage-slider').slick({
				dots: false,
				arrows: true,
				infinite: true,
				speed: 1000,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				responsive: [

				
					{
						breakpoint: 992,
						settings: "unslick",
					},
				]
			});
		},


		portfolioSlider: function () {
			jQuery('.single-portfolio-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				adaptiveHeight: true,
				asNavFor: '.single-portfolio-thumbnail-slider',
				infinite: false,
			  });
			  jQuery('.single-portfolio-thumbnail-slider').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				asNavFor: '.single-portfolio-slider',
				dots: false,
				focusOnSelect: true,
				// centerMode:true,
				// centerPadding:0,
				arrows: true,
				infinite: false,
				responsive: [

				
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
						}

					},
				]
			  });
		},

		filterOpener: function () {
			jQuery(".filter-block .theme-btn").on('click', function () {
				$('.filter-block .theme-btn').not(this).removeClass('show');
				$(this).toggleClass('show');  
			});

			

			jQuery(".filter-block .single-checkbox input").change(function () {
				jQuery(".single-filter-block .theme-btn").removeClass('show');
			});

			

		},

		lightboxOverwrites: function () {
			$(document).ready(function() {
				$('.lb-closeContainer').appendTo('.lb-container'); 
		});
			lightbox.option({
				// 'disableScrolling': true,
				// 'fitImagesInViewport': true,
				'showImageNumberLabel': false
			  })
		},

		 languageTrigger: function () {
      jQuery(".language-selector-trigger").on("click", function (e) {
        // e.preventDefault();
        jQuery(".lang-switcher .sub-menu").slideToggle();
        jQuery(this).toggleClass("rotate");
      });
    },

	







		


	};

	ahus.init();

})(jQuery);


